
import { Base } from '../base-component';

import './contact-us.component.scss';

import { MediaQueryService } from '../../services/media-query.service';

export class ContactUs extends Base {

	contactTitles: Element[];
	contactTimes: Element[];
	contactDetails: Element[];

	constructor(element: Element){
		super(element);
	}

	init() {

		this.contactTitles = Array.from(this.element.querySelectorAll('.contact-us__items--box .js-contact-us-title'));
		this.contactTimes = Array.from(this.element.querySelectorAll('.contact-us__items--box .js-contact-us-times'));
		this.contactDetails = Array.from(this.element.querySelectorAll('.contact-us__items--box .js-contact-us-details'));
		
		setTimeout(() => {
			this.equalHeights(this.contactTitles);
			this.equalHeights(this.contactTimes);
			this.equalHeights(this.contactDetails);
		}, 100);

	}

	bindEvents() {
		window.addEventListener('resize', this.onResize.bind(this));
		window.addEventListener('orientationchange', this.onResize.bind(this));
	}

	onResize() {

		setTimeout(() => {
			this.equalHeights(this.contactTitles);
			this.equalHeights(this.contactTimes);
			this.equalHeights(this.contactDetails);
		}, 100);

	}

	equalHeights(elements) {

		this.defaultHeights(elements);

		if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {

			let tallestElement = 0;

			for (let i = 0; i < elements.length; i++) {

				let el = elements[i];
				let elHeight = el.offsetHeight;

				if (elHeight > tallestElement) {
					tallestElement = elHeight;
				}

			}

			for (let i = 0; i < elements.length; i++) {
				elements[i].style.height = `${tallestElement}px`;
			}

		}

	}

	defaultHeights(elements) {

		for (let i = 0; i < elements.length; i++) {
			elements[i].style.height = 'auto';
		}

	}

}



// WEBPACK FOOTER //
// ./components/contact-us/contact-us.component.ts